// extracted by mini-css-extract-plugin
export default {"outlet":"workspaces_outlet__QJsqv","title":"workspaces_title__4oCrg","workspaceColumn":"workspaces_workspaceColumn__kI13e","workspaceInfo":"workspaces_workspaceInfo__Hh2jg"};